import { render } from "./ChitotriosidasePlasma.vue?vue&type=template&id=c4005152&scoped=true"
import script from "./ChitotriosidasePlasma.vue?vue&type=script&lang=js"
export * from "./ChitotriosidasePlasma.vue?vue&type=script&lang=js"

import "./ChitotriosidasePlasma.vue?vue&type=style&index=0&id=c4005152&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4005152"]])

export default __exports__